// Kiosk version — shown in the admin login modal so staff can verify
// which version a given iPad is running. Bump on each release.
//
// Note: this is *not* what drives the auto-update mechanism — that
// compares the hashed JS bundle filename in `/index.html` against the
// running document (see `useAutoUpdate.ts`).
export const KIOSK_VERSION = 'v115'
export const KIOSK_BUILD_DATE = '2026-04-26'
